import SnackbarAlert from '@pinecone-experience/timber/Feedback/SnackbarAlert';
import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {clearNotification} from '../../actions/notificationActions';
import {useActiveNotification} from '../../hooks/selectors';

const styles = {
  alert: {maxWidth: '400px'},
};

function NotificationAlert() {
  const activeNotification = useActiveNotification();
  const dispatch = useDispatch();
  const onClose = useCallback(() => {
    dispatch(clearNotification());
  }, [dispatch]);
  if (!activeNotification) {
    return null;
  }
  return (
    <SnackbarAlert
      itemStatus={activeNotification.type}
      alertText={activeNotification.text}
      onClose={onClose}
      autoHideDuration={3000}
      anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
      sx={styles.alert}
    />
  );
}

export default NotificationAlert;
